import { Box, Grid } from '@mui/material';
import styled from 'styled-components';

export const Row = styled(Box)`
  display: flex;
  flex-direction: row;
`;

export const RowElipsis = styled(Row)`
  && {
    overflow: hidden;
    white-space: nowrap;
    max-height: 16px;
    text-overflow: ellipsis;
    justify-content: flex-start;
    text-align: left;
  }
`;
export const ElipsisSpan = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Column = styled(Box)`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const AlignStartColumn = styled(Column)`
  align-items: flex-start;
`;

export const AlignEndColumn = styled(Column)`
  align-items: flex-end;
`;

export const JustifyCenterColumn = styled(Column)`
  justify-content: center;
`;

export const SpaceBetweenRow = styled(Row)`
  justify-content: space-between;
`;

export const CenteredSpaceBetweenRow = styled(SpaceBetweenRow)`
  align-items: center;
  width: 100%;
`;

export const CenteredRow = styled(Row)`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const JustifyStartRow = styled(CenteredRow)`
  justify-content: start;
  align-items: center;
`;

export const JustifyEndRow = styled(Row)`
  justify-content: flex-end;
  align-items: center;
`;

export const AlignTextRight = styled.div`
  align-text: right;
`;

export const FullWidthJustifyEndRow = styled(JustifyEndRow)`
  width: 100%;
`;
export const FullWidthJustifyStartRow = styled(JustifyStartRow)`
  width: 100%;
`;

export const PaddingRight16 = styled.div`
  padding-right: 16px;
`;

export const PaddingLeft8 = styled.div`
  padding-left: 8px;
`;

export const PaddingRight8 = styled.div`
  padding-right: 8px;
`;

export const JustifyCenterAlignEndColumn = styled(Column)`
  && {
    justify-content: center;
    align-items: flex-end;
  }
`;

export const SpaceBetweenColumn = styled(Column)`
  && {
    justify-content: space-between;
    align-items: flex-start;
    height: 100%;
  }
`;

export const SpaceBetweenAlignCenterColumn = styled(Column)`
  && {
    justify-content: space-between;
    align-items: center;
    height: 100%;
  }
`;

export const AlignCenterColumn = styled(Column)`
  && {
    align-items: center;
    justify-content: center;
  }
`;

export const AlignStartRow = styled(Row)`
  && {
    align-items: flex-start;
  }
`;

export const AlignCenterRow = styled(Row)`
  && {
    align-items: center;
    justify-content: center;
  }
`;

export const JustifyEndColumn = styled(Column)`
  && {
    align-items: flex-start;
    justify-content: flex-end;
    height: 100%;
  }
`;

export const FlexGrow = styled.div`
  flex: 1;
`;

export const ScrollableGrid = styled(Grid)<{ $scrollMarginTop?: number }>`
  scroll-margin-top: ${(props) => props.$scrollMarginTop || 56}px;
`;
